import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom"
import { can } from "../../utils/can";

export default function AddAgent() {
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [error, setError] = useState({});
    const [isScroll, setIsScroll] = useState(false);
    const [success, setSuccess] = useState("");
     const { agentId } = useParams();
     const isEdit = Boolean(agentId);

    const token = localStorage.getItem("adminToken");
    const API_URL = process.env.REACT_APP_BASE_URL_API || "";

    const baseName = window.location.pathname.split("/").pop();
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        email: "",
        password: "",
        address: "",
        dob: "",
        state_id: "",
        city_id: "",
        pincode: "",
        status: 'Deactive',
    });

    /* ================= FETCH STATE ================= */
    const fetchState = async (countryId) => {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL_API}/api/front/state/${countryId}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );
        const data = await res.json();
        if (data.status) setState(data.data);
    };

    /* ================= FETCH CITY ================= */
    const fetchCity = async (stateId) => {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL_API}/api/front/city/${stateId}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );
        const data = await res.json();
        if (data.status) setCity(data.data);
    };

    /* ================= INPUT CHANGE ================= */
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]:
            type === "checkbox"
                ? checked ? "Active" : "Deactive"
                : value,
        }));

        if (name === "state_id") {
            fetchCity(value);
            setForm((prev) => ({ ...prev, city_id: "" }));
        }
    };

    /* ================= VALIDATION ================= */
    const validate = () => {
        const errs = {};

        if (!form.name.trim()) errs.name = "Agent Name is required";
        if (!form.email.trim()) errs.email = "Email ID is required";
        else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)
        )
            errs.email = "Enter valid email address";

        if (!form.mobile.trim()) errs.mobile = "Mobile No. is required";
        else if (!/^[0-9]{10}$/.test(form.mobile))
            errs.mobile = "Enter valid 10 digit mobile number";
        else if (form.mobile.length !== 10) errs.mobile = "Mobile No. must be 10 digits";

        if (!form.password) errs.password = "Password is required";
        if (!form.password || form.password.length < 6)
            errs.password = "Password must be at least 6 characters";
        if (!form.address.trim()) errs.address = "Address is required";
        if (!form.state_id) errs.state = "State is required";
        if (!form.city_id) errs.city = "City is required";
        if (!form.dob) errs.dob = "Date of Birth is required";
        if (!form.pincode.trim()) errs.pincode = "Pincode is required";
        else if (!/^[0-9]{6}$/.test(form.pincode))
            errs.pincode = "Enter valid 6 digit pincode";

        setError(errs);
        return Object.keys(errs).length === 0;
    };

    // update fetch agent data
    useEffect(() => {
    if (!isEdit) return;

    const fetchAgent = async () => {
        try {
            const res = await fetch(
                `${API_URL}/api/admin/agents/${agentId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await res.json();

            if (data.status) {
                setForm({
                    name: data.data.name || "",
                    mobile: data.data.mobile || "",
                    email: data.data.email || "",
                    password: data.data.password_show || "", // keep empty on update
                    address: data.data.address || "",
                    dob: data.data.dob ? new Date(data.data.dob).toISOString().split('T')[0] : "",
                    state_id: data.data.state_id || "",
                    city_id: data.data.city_id || "",
                    pincode: data.data.pincode || "",
                    status: data.data.status || "Deactive",
                });

                if (data.data.state_id) {
                    fetchCity(data.data.state_id);
                }
            }
        } catch (err) {
            console.error(err);
        }
    };

    fetchAgent();
}, [agentId]);

    /* ================= SUBMIT ================= */
    const handleSubmit = async (e) => {
        if(can("add_agent", "create") === false){
            alert("You don't have permission to perform this action.");
            return;
        }

        e.preventDefault();

        if (!validate()) {
            setIsScroll(true);
            return;
        }

        try {
              const url = isEdit
                ? `${API_URL}/api/admin/agents/update/${agentId}`
                : `${API_URL}/api/admin/agents/create`;

                    const method = isEdit ? "PUT" : "POST";
                    const res = await fetch(url, {
                    method,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(form),
                });

            const data = await res.json();
            if (data.status) {
                setSuccess("Agent added successfully");

                setForm({
                    name: "",
                    mobile: "",
                    email: "",
                    password: "",
                    address: "",
                    state_id: "",
                    city_id: "",
                    pincode: "",
                    status: 'Deactive',
                });
                setCity([]);

                navigate('/agent/view-agent', { replace:true});
            }
            else {
                if(data.message === "Mobile number already registered"){
                    setError({ mobile: data.message });
                }
                else if(data.message === "Email already registered"){
                    setError({ email: data.message });
                }else{
                    alert(data.message || "Failed to add agent");
                }
                
            }
        } catch (err) {
            console.error("Validation Error:", err);
            return;
        }

    };

    /* ================= SCROLL ================= */
    useEffect(() => {
        if (isScroll) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setIsScroll(false);
        }
    }, [isScroll]);

    useEffect(() => {
        fetchState('68cd11b001f6aa3fe367470d'); // default country id
    }, []);



    const generatePassword = () => {
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const length = Math.floor(Math.random() * 3) + 8; // 8, 9 or 10
        let password = "";

        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return password;
    };
    const handleGeneratePassword = () => {
        const newPassword = generatePassword();

        setForm((prev) => ({
            ...prev,
            password: newPassword,
        }));
    };
   
    useEffect(() => {
            handleGeneratePassword();
        }, []);

    const today = new Date();
    const maxDate = new Date(today.setFullYear(today.getFullYear() - 18))
    .toISOString()
    .split("T")[0];

    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />
                <Header pageTitle={'Add Agent'}/>

                <>
                    <div className="right_col" role="main">
                       

                        <div className="x_panel">
                            <div className="x_title">
                                <h2> Entry</h2>
                                <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                                    <li>
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up" />
                                        </a>
                                    </li>
                                </ul>
                                <div className="clearfix" />
                            </div>

                            <div className="x_content">
                                <div className="row">
                                    <form onSubmit={handleSubmit}>
                                        <div className="col-sm-12">
                                            <div className="filtercont">
                                                <div className="row">

                                                    <div className="col-12 col-sm-4 mb-3">
                                                        <label>Agent Name <span className="red">*</span></label>
                                                        <input type="text" name="name" className="form-control"
                                                            value={form.name} onChange={handleChange} />
                                                        {error.name && <p className="text-danger">{error.name}</p>}
                                                    </div>

                                                    <div className="col-12 col-sm-4 mb-3">
                                                        <label>Mobile No. <span className="red">*</span></label>
                                                        <input type="number" name="mobile" className="form-control"
                                                            value={form.mobile} onChange={handleChange} maxLength={10} />
                                                        {error.mobile && <p className="text-danger">{error.mobile}</p>}
                                                    </div>

                                                    <div className="col-12 col-sm-4" />

                                                    <div className="col-12 col-sm-4 mb-3">
                                                        <label>Email ID</label>
                                                        <input type="text" name="email" className="form-control"
                                                            value={form.email} onChange={handleChange} />
                                                        {error.email && <p className="text-danger">{error.email}</p>}
                                                    </div>

                                                    <div className="col-12 col-sm-4 mb-3">
                                                        <label>Password <span className="red">*</span></label>
                                                        <div className="input-group">
                                                        <input type="text" name="password" className="form-control"
                                                            value={form.password} onChange={handleChange} />
                                                             <button
                                                                    type="button"       
                                                                    className="btn-sm btn-light"
                                                                    onClick={handleGeneratePassword}
                                                                >
                                                                    <i className="fa fa-refresh"></i>
                                                                    Generate
                                                                </button>
                                                            </div>
                                                        {error.password && <p className="text-danger">{error.password}</p>}
                                                    </div>
                                                    <div className="col-lg-12"></div>

                                                    <div className="col-12 col-sm-4 mb-3">
                                                        <label>Date of Birth <span className="red">*</span></label>
                                                        <input type="date" name="dob" className="form-control"
                                                            value={form.dob} onChange={handleChange}  max={maxDate} />
                                                        {error.dob && <p className="text-danger">{error.dob}</p>}
                                                    </div>

                                                    <div className="col-lg-12"><hr /></div>

                                                    <div className="col-12 col-sm-8 mb-3">
                                                        <label>Street Address <span className="red">*</span></label>
                                                        <textarea className="form-control" name="address"
                                                            value={form.address} onChange={handleChange} />
                                                        {error.address && <p className="text-danger">{error.address}</p>}
                                                    </div>

                                                    <div className="col-lg-12"></div>
                                                    <div className="col-12 col-sm-3 mb-3">
                                                        <label>State <span className="red">*</span></label>
                                                        <select className="form-select" name="state_id"
                                                            value={form.state_id} onChange={handleChange}>
                                                            <option value="">Select</option>
                                                            {state.map((s) => (
                                                                <option key={s._id} value={s._id}>{s.name}</option>
                                                            ))}
                                                        </select>
                                                        {error.state && <p className="text-danger">{error.state}</p>}
                                                    </div>

                                                    <div className="col-12 col-sm-3 mb-3">
                                                        <label>City <span className="red">*</span></label>
                                                        <select className="form-select" name="city_id"
                                                            value={form.city_id} onChange={handleChange}>
                                                            <option value="">Select</option>
                                                            {city.map((c) => (
                                                                <option key={c._id} value={c._id}>{c.name}</option>
                                                            ))}
                                                        </select>
                                                        {error.city && <p className="text-danger">{error.city}</p>}
                                                    </div>

                                                    <div className="col-12 col-sm-2 mb-3">
                                                        <label>Pincode <span className="red">*</span></label>
                                                        <input type="number" maxLength={6} name="pincode" className="form-control"
                                                            value={form.pincode} onChange={handleChange} />
                                                        {error.pincode && <p className="text-danger">{error.pincode}</p>}
                                                    </div>

                                                    <div className="col-lg-12"></div>
                                                    <div className="col-12 col-sm-5">
                                                        <input type="checkbox" id="active" name="status" value="Active"
                                                            checked={form.status === "Active"} onChange={handleChange} />
                                                        <label htmlFor="active" className="form-label">
                                                            Active/Deactive
                                                        </label>
                                                    </div>

                                                    <div className="col-12 col-sm-3 text-right">
                                                        <button type="submit" className="btn sitebtn d-inline-block">
                                                            Submit
                                                        </button>
                                                        {success && <p className="text-success mt-2">{success}</p>}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

                <Footer />
            </div>
        </div>
    );
}
